import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=2c5a6758&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
import style0 from "./Report.vue?vue&type=style&index=0&id=2c5a6758&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a6758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5a6758')) {
      api.createRecord('2c5a6758', component.options)
    } else {
      api.reload('2c5a6758', component.options)
    }
    module.hot.accept("./Report.vue?vue&type=template&id=2c5a6758&scoped=true", function () {
      api.rerender('2c5a6758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/MyBeans/Report.vue"
export default component.exports